/**
 * Keeps the list a product was last interacted with, so add_to_cart can be
 * attributed to the category, search result or reorder list it came from.
 * The context is short lived - a stale context is worse than no context.
 */

const MAX_AGE_MS = 10000;

let pending = null;

export const setListContext = (articleNumber, listId, listName) => {
    if (!articleNumber) {
        return;
    }
    pending = {
        articleNumber,
        listId,
        listName,
        time: Date.now(),
    };
};

/**
 * Returns and clears the context for an article number, if it is still fresh.
 */
export const consumeListContext = (articleNumber) => {
    if (!pending || pending.articleNumber !== articleNumber) {
        return {};
    }
    const { listId, listName, time } = pending;
    pending = null;
    if (Date.now() - time > MAX_AGE_MS) {
        return {};
    }
    return { item_list_id: listId, item_list_name: listName };
};

/**
 * Reads the list context (rendered by TrackingHelperExtension) that the
 * element belongs to.
 */
export const readListContext = (element) => {
    const container = element && element.closest('[data-tracking-list-id]');
    if (!container) {
        return {};
    }
    return {
        listId: container.dataset.trackingListId,
        listName: container.dataset.trackingListName,
    };
};

/**
 * Reads the item payload that the server rendered on a product card.
 */
export const readTrackingItem = (element) => {
    const holder = element && element.closest('[data-tracking-item]');
    if (!holder) {
        return null;
    }
    try {
        return JSON.parse(holder.dataset.trackingItem);
    } catch (e) {
        return null;
    }
};
